import { render, staticRenderFns } from "./AssignWorkOrder.vue?vue&type=template&id=48896abc&"
import script from "./AssignWorkOrder.vue?vue&type=script&lang=js&"
export * from "./AssignWorkOrder.vue?vue&type=script&lang=js&"
import style0 from "./AssignWorkOrder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports